var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 6"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07.248a.75.75 0 1 1 1.115 1.004L5.656 5.193a.75.75 0 0 1-1.115 0L1.068 1.252A.75.75 0 0 1 2.182.248L5.1 3.571z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;